import { apiCallWithAuth } from "../helper/apiManager";
import { ServiceOperationResult } from "../models/api/serviceOperationResult";
import { IGroupTemplate } from "../models/groupTemplate";
import { API_CENTRE } from "./config";

const BASE_URL = API_CENTRE + "/api/v1/GroupTemplate";

// Lot9 — Gabarits de groupe (couleur + plage horaire par ordre). Centre fourni par le front.
export default class GroupTemplateService {
  static async getAll(centerId?: number): Promise<ServiceOperationResult<IGroupTemplate[]>> {
    try {
      let url = BASE_URL;
      if (centerId != null) url += `?centerId=${centerId}`;
      const result = await apiCallWithAuth(url, "get");
      return new ServiceOperationResult<IGroupTemplate[]>(false, result.data);
    } catch (err: any) {
      return new ServiceOperationResult<IGroupTemplate[]>(true, err);
    }
  }

  // Remplace l'ensemble des gabarits du centre (couleur + plage horaire).
  static async replace(
    templates: IGroupTemplate[],
    centerId?: number
  ): Promise<ServiceOperationResult<IGroupTemplate[]>> {
    try {
      let url = BASE_URL;
      if (centerId != null) url += `?centerId=${centerId}`;
      const result = await apiCallWithAuth(url, "put", templates);
      return new ServiceOperationResult<IGroupTemplate[]>(false, result.data);
    } catch (err: any) {
      return new ServiceOperationResult<IGroupTemplate[]>(true, err);
    }
  }
}
